export const getItemCode = (item: Record<string, string> | undefined | null): string =>
	item?.['ProductCode'] ?? item?.['ItemCode'] ?? item?.['Code'] ?? '';
